import { IntlShape, useIntl } from 'react-intl';
import { Settings, TableColumnSetting, TableColumnsSetting } from '@tlx/astro-shared';
import { useTskContext } from '@Hooks/useTskContext';
import { ColumnType } from '@Hooks/useOrdering.ts';

export type ColumnId = 'NUMBER' | 'STARTDATE' | 'DEPARTMENT' | 'DIVISION' | 'STATUS' | 'PREVIOUS_SALARIES';

export const EMPLOYEE_TABLE_COLUMNS_SETTING_KEY = 'employee-table-columns';

export const getDefaultColumns = (intl: IntlShape, showDepartment?: boolean, showDivision?: boolean): ColumnType[] => {
    const { formatMessage } = intl;
    const defaultColumns: ColumnType[] = [
        {
            id: 'NUMBER',
            label: formatMessage({ id: 'th_number_short' }),
            width: '0.2fr',
        },
        {
            id: 'STARTDATE',
            label: formatMessage({ id: 'text_employment' }),
            width: '1fr',
        },
    ];
    if (showDepartment) {
        defaultColumns.push({
            id: 'DEPARTMENT',
            label: formatMessage({ id: 'text_department' }),
            width: '1fr',
        });
    }
    if (showDivision) {
        defaultColumns.push({
            id: 'DIVISION',
            label: formatMessage({ id: 'text_division' }),
            width: '1fr',
        });
    }
    const restColumns: ColumnType[] = [
        {
            id: 'STATUS',
            label: formatMessage({ id: 'text_status' }),
            width: '2fr',
        },
        {
            id: 'PREVIOUS_SALARIES',
            label: formatMessage({ id: 'text_salary_payments' }),
            width: '3fr',
        },
    ];
    defaultColumns.push(...restColumns);

    return defaultColumns;
};

export function EmployeeTableSettings() {
    const intl = useIntl();
    const { showDepartmentIsWageAdmin, hasDivision } = useTskContext();
    const defaultColumns = getDefaultColumns(intl, showDepartmentIsWageAdmin, hasDivision);
    const label = intl.formatMessage({ id: 'text_columns' });

    return (
        <Settings>
            <TableColumnsSetting
                name={EMPLOYEE_TABLE_COLUMNS_SETTING_KEY}
                label={label}
                aria-label={label}
                defaultColumns={defaultColumns.map((column) => column.id)}
            >
                {defaultColumns.map((column) => (
                    <TableColumnSetting key={column.id} value={column.id}>
                        {column.label}
                    </TableColumnSetting>
                ))}
            </TableColumnsSetting>
        </Settings>
    );
}
